import { render, staticRenderFns } from "./ImpersonateDialog.vue?vue&type=template&id=23df47fb&scoped=true"
import script from "./ImpersonateDialog.vue?vue&type=script&lang=js"
export * from "./ImpersonateDialog.vue?vue&type=script&lang=js"
import style0 from "./ImpersonateDialog.vue?vue&type=style&index=0&id=23df47fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df47fb",
  null
  
)

export default component.exports